import { Box, Stack } from 'braid-design-system';
import type { ComponentProps } from 'react';

import { GenAIChatLoadingOverlay } from '../LoadingOverlay';

import { ErrorMessage } from './ErrorMessage/ErrorMessage';
import { HeadMessage } from './HeadMessage/HeadMessage';

export interface CareerFeedAIAssistantWidgetContentProps {
  headMessage?: ComponentProps<typeof HeadMessage>['message'];
  contentSection?: ComponentProps<typeof Stack>['children'];
  errorType?: ComponentProps<typeof ErrorMessage>['errorType'] | null;
  isLoading?: boolean;
  socialProofSection?: ComponentProps<typeof Stack>['children'];
  ctaSection?: ComponentProps<typeof Stack>['children'];
}

export const CareerFeedAIAssistantWidgetContent = ({
  headMessage,
  contentSection,
  ctaSection,
  errorType,
  socialProofSection,
  isLoading = false,
}: CareerFeedAIAssistantWidgetContentProps) => (
  <Stack space="small">
    <GenAIChatLoadingOverlay isGenerating={isLoading}>
      <Box paddingY="xxsmall">
        <Stack space="medium">
          {headMessage ? <HeadMessage message={headMessage} /> : null}
          {socialProofSection}
          {contentSection}
          {errorType ? <ErrorMessage errorType={errorType} /> : null}
        </Stack>
      </Box>
    </GenAIChatLoadingOverlay>
    {ctaSection}
  </Stack>
);
